
import React, { useState } from 'react'
import Modal from 'react-modal';
import PostGalleryItem from './PostGalleryItem';
import PostVideoGalleryController from '../controller/PostVideoGalleryController';
import PostVideoGalleryForm from './PostVideoGalleryForm';

function PostVideoGallery({ id }) {

    const { videoGalleries,setVideoGalleries, setAddModalIsOpen, addModalIsOpen, closeModal,refetch} = PostVideoGalleryController(id)

    return (
        <div className="box box-primary">
            <div className="box-header with-border">
                <div className="text-color-light flex-space-between mb-4 ">
                    <h3 className="box-title">Related Videos</h3>
                    <button className="btn btn-dark pull-right" onClick={() => { setAddModalIsOpen(true) }}><i className="fa fa-plus"></i></button>
                </div>
            </div>
            <div className="box-body padding-20 ">
                {videoGalleries && videoGalleries.map(item => (
                    <PostGalleryItem key={item.id} item={item}
                        onDelete={(id) => {
                            let temp = videoGalleries.filter(item => item.id != id)
                            console.log(temp)
                            setVideoGalleries(temp)
                            refetch()
                        }} />
                )
                )}
            </div>

            {addModalIsOpen &&
                <Modal
                    closeTimeoutMS={500}
                    isOpen={addModalIsOpen}
                    onRequestClose={closeModal}
                    className="Modal"
                    overlayClassName="Overlay"
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={closeModal}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 className="modal-title">Add Related Video</h4>
                        </div>
                        <div className="modal-body text-center">
                            <PostVideoGalleryForm postId={id} callback={(item) => {
                                let temp = [item, ...videoGalleries]
                                setVideoGalleries(temp)
                                setAddModalIsOpen(false);
                            }} />
                        </div>

                    </div>
                </Modal>
            }
        </div>
    )
}

export default PostVideoGallery